export default "__VITE_ASSET__Ctar9gV0__"